export const CPCS_REGEX: { [key: string]: RegExp } = {
  ca_pro_ne_aportamasvidacaixa: /\/\/aportamas\.vidacaixa\.es/,
  ca_pre_ne_aportamasvidacaixa: /\/\/precld\.aportamas\.vidacaixa\.es/,
  ca_dev_ne_aportamasvidacaixa: /\/\/vidacaixa\.es/,
};
